__turbopack_context__.v({
  "container": "spinner-module__ptsHJa__container",
  "slice": "spinner-module__ptsHJa__slice",
  "spinner": "spinner-module__ptsHJa__spinner",
});
